module.exports = "https://cdn.realtymogul.com/static/media/mr1_assets.bc2b4420.png";